import React, { PropsWithChildren } from "react";
import { SvgIcon, Chip, useTheme } from "@mui/material";
import { icons } from "../utils/icons";

type SearchCategoryProps = {
    onClick?: () => void;
    isActive: boolean;
    name: string;
    count: number;
    noBackground?: boolean;
};

export const SearchCategory = ({
    onClick,
    isActive,
    name,
    children,
    count,
    noBackground
}: PropsWithChildren<SearchCategoryProps>) => {
    const theme = useTheme();
    const icon = icons[name];
    return (
        <div
            className={`relative flex w-full cursor-pointer items-center rounded-md py-2 px-4 ${
                isActive && "text-sh-red"
            } ${isActive && !noBackground && "bg-red-50"}`}
            onClick={(event) => {
                event.preventDefault();
                onClick && onClick();
            }}
        >
            <SvgIcon
                className="mr-[16px]"
                component={icon[0]}
                inheritViewBox
                style={{
                    width: 24,
                    height: 24,
                    stroke: icon[1]
                        ? isActive
                            ? theme.palette.primary.main
                            : theme.palette.shBlack.main
                        : undefined,
                    fill: icon[1] ? "none" : undefined,
                    strokeWidth: icon[1] ? 1.5 : undefined
                }}
                color={isActive ? "primary" : "sh-black"}
            />
            {children}
            {count > 0 && (
                <Chip
                    className="absolute right-4 w-[40px] border-[1px] border-solid border-sh-200 bg-white text-sm font-medium font-normal text-sh-red"
                    size="small"
                    label={" " + count + " "}
                />
            )}
        </div>
    );
};
